import type { Link as TLink } from '@frontend/libs/types/common'
import type React from 'react'

import { cn } from '@nextui-org/react'
import { Link } from 'react-router-dom'

interface MenuLinkProps
  extends React.DetailedHTMLProps<
    React.AnchorHTMLAttributes<HTMLAnchorElement>,
    HTMLAnchorElement
  > {
  link: TLink
  title: string
}

function MenuLink({
  className,
  link,
  title,
  ...props
}: Readonly<MenuLinkProps>) {
  return (
    <Link
      className={cn(`font-medium uppercase text-primary ${className}`)}
      target={link.target}
      title={link.title}
      to={link.url}
      {...props}
    >
      {title}
    </Link>
  )
}

export default MenuLink
